import React from "react";

const SecureCheckout = ({ userInfo }) => {
  return (
    <div className="card checkout-card">
      {console.log(userInfo, "userInfo")}
      <div className="card-header">
        <h5>Thanh toán an toàn</h5>
      </div>
      <div className="card-body">
        <div>
          <div className="checkout-title">
            <h6 className="mb-2">Thông tin liên lạc</h6>
          </div>
          <div className="checkout-details pb-2 border-bottom mb-4">
            <div className="row">
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Email</label>
                  <input
                    type="email"
                    className="form-control"
                    readOnly
                    value={userInfo.email}
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Điện thoại</label>
                  <input
                    type="text"
                    className="form-control"
                    value={userInfo.phoneNumber}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="checkout-title">
            <h6 className="mb-2">Thông tin của bạn</h6>
          </div>
          <div className="checkout-details">
            <div className="row">
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Tên</label>
                  <input
                    type="text"
                    className="form-control"
                    value={userInfo.fullName.split(" ")[0]}
                    readOnly
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Họ</label>
                  <input
                    type="text"
                    className="form-control"
                    value={
                      userInfo.fullName.trim().split(" ")[
                        userInfo.fullName.trim().split(" ").length - 1
                      ]
                    }
                    readOnly
                  />
                </div>
              </div>
              {/* <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Age</label>
                  <select className="select">
                    <option>Select</option>
                    <option>27</option>
                    <option>25</option>
                  </select>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="mb-3">
                  <label className="form-label">Country</label>
                  <select className="select">
                    <option>Select</option>
                    <option>Barcelona</option>
                    <option>London</option>
                  </select>
                </div>
              </div> */}
              <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label">Địa chỉ</label>
                  <input
                    type="text"
                    className="form-control"
                    value={userInfo.address}
                    readOnly
                  />
                </div>
              </div>
              {/* <div className="col-lg-12">
                <div className="mb-3">
                  <label className="form-label">Address line 2</label>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="mb-3">
                  <label className="form-label">City</label>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="mb-3">
                  <label className="form-label">State</label>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="col-lg-4">
                <div className="mb-3">
                  <label className="form-label">Zip Code</label>
                  <input type="text" className="form-control" />
                </div>
              </div>
              <div className="col-lg-12">
                <div className="mb-0">
                  <label className="form-label">Additional Info</label>
                  <textarea className="form-control" rows="4"></textarea>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SecureCheckout;
